import { createTheme } from '@mui/material';
import blueGrey from '@mui/material/colors/blueGrey';

declare module '@mui/material/styles' {
  interface Palette {
    frimley: Palette['primary'];
    wexham: Palette['primary'];
    heatherwood: Palette['primary'];
  }
  interface PaletteOptions {
    frimley: PaletteOptions['primary'];
    wexham: PaletteOptions['primary'];
    heatherwood: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    frimley: true;
    wexham: true;
    heatherwood: true;
  }
}

export const mainTheme = createTheme({
  palette: {
    primary: {
      main: '#198f77',
    },
    secondary: {
      main: '#005a96',
    },
    frimley: {
      main: '#2980B9',
      contrastText: '#fff',
    },
    wexham: {
      main: '#700331',
      contrastText: '#fff',
    },
    heatherwood: {
      main: '#03705E',
      contrastText: '#fff',
    },
  },
});

export const stagingTheme = createTheme({
  palette: {
    primary: {
      main: blueGrey[500],
    },
    secondary: {
      main: '#005a96',
    },
    frimley: {
      main: '#2980B9',
      contrastText: '#fff',
    },
    wexham: {
      main: '#700331',
      contrastText: '#fff',
    },
    heatherwood: {
      main: '#03705E',
      contrastText: '#fff',
    },
  },
});

export const frimleyParkTheme = createTheme({
  palette: {
    primary: {
      main: '#2980B9',
    },
    secondary: {
      main: '#005a96',
    },
    frimley: {
      main: '#2980B9',
      contrastText: '#fff',
    },
    wexham: {
      main: '#700331',
      contrastText: '#fff',
    },
    heatherwood: {
      main: '#03705E',
      contrastText: '#fff',
    },
  },
});

export const wexhamParkTheme = createTheme({
  palette: {
    primary: {
      main: '#700331',
    },
    secondary: {
      main: '#005a96',
    },
    frimley: {
      main: '#2980B9',
      contrastText: '#fff',
    },
    wexham: {
      main: '#700331',
      contrastText: '#fff',
    },
    heatherwood: {
      main: '#03705E',
      contrastText: '#fff',
    },
  },
});
